// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","divider":"About_divider__efHiD"};